﻿package org.zq.pixelset.model

import androidx.compose.ui.graphics.ImageBitmap

enum class OutputFormat(val label: String, val extension: String) {
    PNG("PNG", "png"),
    JPG("JPG", "jpg"),
    WEBP("WebP", "webp"),
}

enum class ScaleMode(val label: String) {
    Fit("适应"),
    Fill("填充"),
    Stretch("拉伸"),
}

data class SizePreset(val label: String, val width: Int, val height: Int) {
    companion object {
        val presets = listOf(
            SizePreset("自定义", 0, 0),
            SizePreset("1920×1080", 1920, 1080),
            SizePreset("1280×720", 1280, 720),
            SizePreset("800×600", 800, 600),
            SizePreset("640×480", 640, 480),
            SizePreset("400×400", 400, 400),
        )
    }
}

data class PickedImage(
    val name: String,
    val bytes: ByteArray,
    val sizeBytes: Long,
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        other as PickedImage
        return name == other.name && bytes.contentEquals(other.bytes) && sizeBytes == other.sizeBytes
    }

    override fun hashCode(): Int {
        var result = name.hashCode()
        result = 31 * result + bytes.contentHashCode()
        result = 31 * result + sizeBytes.hashCode()
        return result
    }
}

data class DecodedImage(
    val width: Int,
    val height: Int,
    val pixels: IntArray,
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        other as DecodedImage
        return width == other.width && height == other.height && pixels.contentEquals(other.pixels)
    }

    override fun hashCode(): Int {
        var result = width
        result = 31 * result + height
        result = 31 * result + pixels.contentHashCode()
        return result
    }
}

data class ProcessSettings(
    val targetWidth: Int,
    val targetHeight: Int,
    val lockAspectRatio: Boolean,
    val format: OutputFormat,
    val quality: Float,
    val scaleMode: ScaleMode,
)

data class ProcessedResult(
    val bytes: ByteArray,
    val width: Int,
    val height: Int,
    val bitmap: ImageBitmap,
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        other as ProcessedResult
        return bytes.contentEquals(other.bytes) && width == other.width && height == other.height
    }

    override fun hashCode(): Int = bytes.contentHashCode()
}

private fun formatDecimal(value: Double): String {
    val scaled = (value * 10).toInt()
    return "${scaled / 10}.${scaled % 10}"
}

fun formatFileSize(bytes: Long): String {
    if (bytes < 1024) return "$bytes B"
    if (bytes < 1024 * 1024) return "${formatDecimal(bytes / 1024.0)} KB"
    return "${formatDecimal(bytes / (1024.0 * 1024.0))} MB"
}

fun sizeReductionPercent(originalBytes: Long, processedBytes: Long): Int {
    if (originalBytes <= 0) return 0
    return ((1.0 - processedBytes.toDouble() / originalBytes) * 100).toInt().coerceIn(-999, 99)
}
